<div class="form-check">
    <input class="form-check-input" type="checkbox" [(ngModel)]="valor" (change)="cambiar()"  id="flexCheckDefault">
    <label class="form-check-label" for="flexCheckDefault">
      Web
    </label>
</div> 